module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.$route.name !== 'survey') ? _c('navbar-overlay') : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "page-wrapper",
    staticStyle: {
      "min-height": "600px"
    }
  }), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b132472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 982
// module chunks = 1